import "./compliance-video.css";
import { manageLoopingVideo } from "./video-playback-manager";

const VIDEO_SRC = "/cadena_v2.mp4";

function installComplianceVideo() {
  const section = document.querySelector("#compliance");
  if (!section) return false;
  if (section.querySelector(".compliance-video-stage")) return true;

  const inner = section.querySelector(":scope > .mx-auto");
  const copy = inner?.firstElementChild;
  const cards = copy?.nextElementSibling;
  if (!inner || !copy || !cards) return false;

  section.classList.add("compliance-video-section");
  inner.classList.add("compliance-video-layout");
  copy.classList.add("compliance-video-copy");
  cards.classList.add("compliance-video-cards");

  const stage = document.createElement("div");
  stage.className = "compliance-video-stage";
  stage.innerHTML = `
    <video
      class="compliance-video-element"
      src="${VIDEO_SRC}"
      muted
      loop
      playsinline
      preload="metadata"
      aria-label="Animation CARTHY autour de la conformité, de la infrastructure et de la protection des données"
    ></video>
    <div class="compliance-video-vignette" aria-hidden="true"></div>
  `;

  inner.insertBefore(stage, cards);

  const video = stage.querySelector("video");
  if (video) manageLoopingVideo(video, stage);

  return true;
}

function boot() {
  if (installComplianceVideo()) return;

  const observer = new MutationObserver(() => {
    if (installComplianceVideo()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
